import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import * as BPActions from '../../../store/actions/bookpage.action';
import { BookPageComponent } from '../../../shared/components/book-page/book-page.component';
import { RecPlanSearchService } from '../../rec-plan-search-service';

@Component({
  selector: 'app-rec-plan-bp-search',
  providers: [RecPlanSearchService],
  templateUrl: './rec-plan-bp-search.component.html',
  styleUrls: ['./rec-plan-bp-search.component.css']
})
export class RecPlanBpSearchComponent implements OnInit {

  @ViewChild(BookPageComponent, { static: false }) bookpageChild;
  @ViewChild('f', { static: true }) bookPageSearchForm: NgForm;
  parentForm: UntypedFormGroup;
  appurl: string;
  bookType: string;
  
  constructor(private router: Router, private store: Store<AppState>, private fb: UntypedFormBuilder,
              private service: RecPlanSearchService, @Inject('BASE_URL') baseUrl: string) {
    this.appurl = baseUrl;
    this.bookType = 'Plan';
  }


  addRecToStore(book, page) {
    this.store.dispatch(new BPActions.AddBP(
      { docNumPrimary: book, docNumSecondary: page }));
  }


  delRecFromStore(index) {
    this.store.dispatch(new BPActions.RemoveBP(index));
  }



  ngOnInit() {
    //this.parentForm = this.fb.group({
    //});

    //this.bookPageSearchForm.form = this.fb.group({});

  }



  onSubmit(e) {
    if (this.bookPageSearchForm.valid) {

      this.delRecFromStore(0);
      this.addRecToStore(
        this.bookpageChild.utilityobj.docNumPrimary,
        this.bookpageChild.utilityobj.docNumSecondary);

      let book = this.bookpageChild.utilityobj.docNumPrimary;
      let page = this.bookpageChild.utilityobj.docNumSecondary;
      book = (String('0').repeat(4) + book).substr((4 * -1), 4).toUpperCase();
      page = (String('0').repeat(4) + page).substr((4 * -1), 4).toUpperCase();
      let url = "blah";

      let loc = localStorage.getItem("machineLocation")

      //check if index exists and is over 5.1.17
      this.service.GetPlanDoc(book, page).toPromise()
        .then(res => {
          //var cutoffDt = new Date('5/1/2017');
          //var fileDt = new Date(res.fileDate);
          //          if (fileDt < cutoffDt || res.planID === 0) {
          //if ((+res.book < 238 ) || (+res.book === 238 && +res.page < 37)) {
          if (this.service.isInPlanFolder(res.book, res.page)) {
          var planID = res.planID;
            if (+book < 238)
              planID = 0;
            //url = '/rec-plan-name-doc-disp-pg/' + book + '/' + page + '/' + res.planID;
            const url = this.router.createUrlTree(['/rec-plan-name-doc-disp-pg/', book, page, planID]);
            const tUrl = this.appurl + url.toString().substring(1);
            if (loc == '1' || loc == '2') {
              var params = [
                'height=' + screen.height,
                'width=' + screen.width,
                'fullscreen=yes' // only works in IE, but here for completeness
              ].join(',');

              var popup = window.open(tUrl, 'popup_window', params);
              if (popup) {
                popup.moveTo(0, 0);
                popup.focus();
              } else {
                alert('Popup was blocked. Please allow popups for this site.');
              }

            } else {
              window.open(tUrl, '_blank');
            }
            //this.router.navigate(['/rec-plan-name-doc-disp-pg/', book, page, planID]);
          }
          else {
            const url = this.router.createUrlTree(['/rec-address-doc-disp-pg', res.planID, book, page]);
            const tUrl = this.appurl + url.toString().substring(1);
            if (loc == '1') {
              var params = [
                'height=' + screen.height,
                'width=' + screen.width,
                'fullscreen=yes' // only works in IE, but here for completeness
              ].join(',');

              var popup = window.open(tUrl, 'popup_window', params);
              if (popup) {
                popup.moveTo(0, 0);
                popup.focus();
              } else {
                alert('Popup was blocked. Please allow popups for this site.');
              }
            } else {
              window.open(tUrl, '_blank');
            }
         }
        });

      //let url = '/rec-plan-name-doc-disp-pg/' + book + '/' + page + '/0';
      //this.router.navigate(['/rec-plan-bp-result-pg']);
      //this.router.navigate([url]);
    }
    else {
      this.validateAllFormFields(this.bookPageSearchForm.form);
    }
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof UntypedFormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  ngAfterViewInit() {

    this.parentForm = this.fb.group({
    });

    this.bookPageSearchForm.form = this.fb.group({});

    this.bookPageSearchForm.form.addControl('bookPageForm', this.bookpageChild.form);
    this.bookpageChild.form.setParent(this.bookPageSearchForm.form);
  }
}
